import ChatsListHeader from './ChatsListHeader';
import ChatsListItem from './ChatsListItem';
import ChatsGroup from './ChatsGroup';
import { Chat, ChatGroup } from '@/types/chats';
import { useState } from 'react';
import { useExpandedGroups } from '@/hooks/useExpandedGroups';

const ChatsList = ({ chats }: { chats: Chat[] }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const { expandedGroupIds, toggleGroup } = useExpandedGroups();

  const filteredChats = searchQuery
    ? chats.filter((chat) => chat.title?.toLowerCase().includes(searchQuery.toLowerCase()))
    : chats;

  const chatsWithoutGroups = filteredChats.filter((chat) => chat.chatGroups.length === 0);

  const groupedMap = new Map<string, ChatGroup & { chats: Chat[] }>();

  filteredChats.forEach((chat) => {
    chat.chatGroups.forEach((group) => {
      const item = groupedMap.get(group.id);
      if (item) item.chats.push(chat);
      else groupedMap.set(group.id, { ...group, chats: [chat] });
    });
  });

  const normalizedChatGroups = Array.from(groupedMap.values());
  const sortedChatGroups = normalizedChatGroups.sort((a, b) => a.sort - b.sort);

  return (
    <div id="chats-list" className="h-full w-full overflow-y-auto overflow-x-hidden bg-white">
      <ChatsListHeader onSearch={setSearchQuery} />
      <div>
        {sortedChatGroups.map((chatGroup) => (
          <ChatsGroup
            isExpandedBySearch={searchQuery.length > 0}
            key={chatGroup.id}
            groupTitle={chatGroup.title}
            chats={chatGroup.chats}
            isExpanded={expandedGroupIds.has(chatGroup.id)}
            onToggle={() => toggleGroup(chatGroup.id)}
          />
        ))}
        {chatsWithoutGroups.map((chat) => (
          <ChatsListItem className="max-md:h-[80px]" key={chat.id} chat={chat} />
        ))}
      </div>
    </div>
  );
};

export default ChatsList;
